/* cubed-touch.js: the computer's hover, for a finger (the owner, 2026-10-19).
   A finger on a "Look closer." tile brings it forward and steps the other back; a finger on a product
   card changes its picture (the second photo, the second colour dyed in, or the zoom), as the pointer
   does on a computer. The forms live in cubed-phone.css (.is-pressed, .is-touched for :hover).
   It follows the finger itself (touch events), not the pointer: the browser cancels a pointer the
   moment the page starts to scroll, which dropped the effect mid-move (the owner saw it as a glitch).
   So the effect holds for as long as the finger is down, through a scroll too. A tile then stays
   forward after the finger lifts, until the next touch anywhere else on the page (the owner,
   2026-10-20); a card's change leaves a moment after the lift, so a quick tap still shows it answering.
   A finger held still on a tile or a card is looking, as a resting pointer would: lifting it opens
   nothing, and no link or picture menu (nor its long-press buzz) comes up. A tap opens the page.
   Whether this is a finger, theme.liquid has said on <html> (cubed-finger); a touch on a screen it
   did not flag (a Galaxy phone turned sideways claims a mouse) flags it then. A mouse never comes here:
   it sends no touch events. */
(function () {
  "use strict";
  console.log("⚙️ [Function Started]: cubed-touch");
  var root = document.documentElement;
  var PRESSABLE = ".sb-tile, .sb-card, .sb-kind, .sb-kindcard";
  var LINGER = 260; // ms the effect stays after the finger lifts
  var HOLD = 450;   // ms a still finger must stay down to count as looking, not tapping
  var SLOP = 10;    // px a finger may drift and still be "still"

  var current = null, lingering = null, timer = null, stuck = null;
  var downAt = 0, liftedAt = -Infinity, x0 = 0, y0 = 0, moved = false, looked = false;

  function isTile(el) { return el.classList.contains("sb-tile"); }

  function press(el) {
    if (isTile(el)) {
      el.classList.add("is-pressed");
      el.parentElement.classList.add("is-pressing");
    } else {
      el.classList.add("is-touched");
    }
  }

  function release(el) {
    if (!el) return;
    if (isTile(el)) {
      el.classList.remove("is-pressed");
      if (!el.parentElement.querySelector(".is-pressed")) el.parentElement.classList.remove("is-pressing");
    } else {
      el.classList.remove("is-touched");
    }
  }

  document.addEventListener("touchstart", function (ev) {
    if (!root.classList.contains("cubed-finger")) {
      root.classList.add("cubed-finger");
      console.log("📦 [State Update]: a touch on a screen that claimed a mouse, it is a finger now");
    }
    var el = ev.target.closest ? ev.target.closest(PRESSABLE) : null;
    if (stuck && el !== stuck) {
      release(stuck);
      stuck = null;
      console.log("📦 [State Update]: a touch elsewhere, the tile steps back");
    }
    if (ev.touches.length > 1) { release(current); current = null; stuck = null; return; } // a pinch is no press
    clearTimeout(timer);
    if (lingering && lingering !== el) release(lingering);
    lingering = null;
    looked = false;
    if (!el) return;
    current = el;
    downAt = performance.now();
    x0 = ev.touches[0].clientX;
    y0 = ev.touches[0].clientY;
    moved = false;
    press(el);
    console.log("👆 [Trigger]: finger on", isTile(el) ? "a tile" : "a card");
  }, { passive: true, capture: true });

  document.addEventListener("touchmove", function (ev) {
    if (!current || moved) return;
    var t = ev.touches[0];
    if (Math.abs(t.clientX - x0) > SLOP || Math.abs(t.clientY - y0) > SLOP) moved = true;
  }, { passive: true, capture: true });

  function lift(ev) {
    if (!current || ev.touches.length) return;
    liftedAt = performance.now();
    looked = !moved && liftedAt - downAt >= HOLD;
    if (looked) console.log("📦 [State Update]: the finger was looking, its lift opens nothing");
    var el = current;
    current = null;
    if (isTile(el)) {
      stuck = el;
      console.log("📦 [State Update]: the tile stays forward until a touch elsewhere");
      return;
    }
    lingering = el;
    timer = setTimeout(function () { release(lingering); lingering = null; }, LINGER);
  }
  document.addEventListener("touchend", lift, { passive: true, capture: true });
  document.addEventListener("touchcancel", lift, { passive: true, capture: true });

  // Back on the page from the tile's list (the page kept as it was left): the tile steps back.
  window.addEventListener("pageshow", function (ev) {
    if (!ev.persisted || !stuck) return;
    console.log("👆 [Trigger]: back on the page, the tile steps back");
    release(stuck);
    stuck = null;
  });

  // The click a still, held finger leaves behind (some phones send one) opens nothing.
  document.addEventListener("click", function (ev) {
    if (!looked) return;
    looked = false;
    if (ev.target.closest && ev.target.closest(PRESSABLE)) { ev.preventDefault(); ev.stopPropagation(); }
  }, true);
  // The long-press menu (and its buzz) on a link or a picture: never on a tile or a card under a
  // finger, nor just after one lifts (a phone may ask as the touch ends). A mouse's right click keeps
  // its menu.
  document.addEventListener("contextmenu", function (ev) {
    var byFinger = current || performance.now() - liftedAt < 600;
    if (byFinger && ev.target.closest && ev.target.closest(PRESSABLE)) ev.preventDefault();
  });
})();
